import { GraphAnalyticInterval } from "@common/utils/graphql";
import { BAR_COLORS } from "./constants";
import { format } from "date-fns";

export const getBarColorFor = (name: string) => {
  let hash = 0;

  // Generate a hash from the input text
  for (let i = 0; i < name.length; i++) {
    const char = name.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32-bit integer
  }

  // Ensure the hash is positive and use modulo to get a valid index
  const index = Math.abs(hash) % BAR_COLORS.length;

  return BAR_COLORS[index];
};

export const formatDateForInterval = (
  date: Date,
  interval: GraphAnalyticInterval,
) => {
  if (
    interval === GraphAnalyticInterval.Daily ||
    interval === GraphAnalyticInterval.Weekly
  ) {
    // Aug 19
    return format(date, "MMM d");
  } else {
    // Aug 2024
    return format(date, "MMM yyyy");
  }
};
